import { render, staticRenderFns } from "./Step3-2.vue?vue&type=template&id=3401664a&scoped=true&"
import script from "./Step3-2.vue?vue&type=script&lang=js&"
export * from "./Step3-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401664a",
  null
  
)

export default component.exports